module.exports = __webpack_public_path__ + "static/img/decor-right.a9833bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sack/decor-right.png
// module id = 0vgk
// module chunks = 1